export default __webpack_public_path__ + "static/media/flag-black.7a109416.svg";